import { Seo } from "../components/Seo";
import { FadeUp, Eyebrow } from "../components/Reveal";
import { useSettings } from "../lib/SettingsContext";

const Section = ({ title, children }) => (
  <section className="space-y-4">
    <h2 className="font-display font-medium text-xl text-ink">{title}</h2>
    <div className="text-sm text-ink/70 leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function PrivacyPage() {
  const { settings } = useSettings();
  const titolare = settings.legal_name || "V32 Group";

  return (
    <div data-testid="privacy-page">
      <Seo
        title="Privacy Policy | V32 Group — V32 Bagni"
        description="Informativa sul trattamento dei dati personali di V32 Group ai sensi della Legge federale sulla protezione dei dati (nLPD)."
      />
      <div className="pt-32 md:pt-40 pb-20 lg:pb-28">
        <div className="max-w-3xl mx-auto px-6 sm:px-10">
          <Eyebrow>Documento legale</Eyebrow>
          <FadeUp>
            <h1 className="mt-6 font-display font-light text-4xl sm:text-5xl tracking-tight text-ink">
              Privacy Policy
            </h1>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-pietra">
              Ultimo aggiornamento: luglio 2026
            </p>
          </FadeUp>
          <FadeUp delay={0.1}>
            <div className="mt-12 space-y-10">
              <Section title="1. Titolare del trattamento">
                <p>
                  Titolare del trattamento dei dati personali raccolti tramite questo
                  sito è {titolare}
                  {settings.address ? `, ${settings.address}` : ""}. Per qualsiasi
                  domanda relativa alla protezione dei dati è possibile contattarci
                  {settings.email ? ` all'indirizzo ${settings.email}` : ""}
                  {settings.phone ? ` o al numero ${settings.phone}` : ""}.
                </p>
                {!settings.legal_name && (
                  <p className="text-ink/50 italic">
                    I dati societari completi saranno pubblicati in questa sezione a
                    seguito della registrazione ufficiale.
                  </p>
                )}
              </Section>

              <Section title="2. Dati raccolti">
                <p>
                  Tramite il modulo «Richiedi un intervento» raccogliamo: nome e
                  cognome o ragione sociale, indirizzo email, numero di telefono,
                  comune e indirizzo dell'intervento, tipologia di cliente, servizio
                  richiesto, informazioni sull'impianto (capacità, marca e modello,
                  numero di circuiti), eventuali fotografie caricate volontariamente
                  e le preferenze di contatto indicate.
                </p>
                <p>
                  Durante la navigazione possono essere raccolti dati tecnici di
                  utilizzo (indirizzo IP, tipo di browser, pagine visitate) in forma
                  aggregata, nel rispetto degli obblighi applicabili in materia di
                  consenso.
                </p>
              </Section>

              <Section title="3. Finalità e base giuridica">
                <p>
                  I dati forniti sono utilizzati esclusivamente per gestire la tua
                  richiesta, confermare prezzo e disponibilità, organizzare
                  l'intervento e dare seguito al rapporto commerciale da te avviato.
                  Il trattamento si basa sul tuo consenso e sulle misure
                  precontrattuali richieste.
                </p>
              </Section>

              <Section title="4. Conservazione e sicurezza">
                <p>
                  I dati sono conservati per il tempo necessario a gestire la
                  richiesta e gli eventuali obblighi contrattuali o legali
                  successivi. Adottiamo misure tecniche e organizzative adeguate a
                  proteggere i dati da accessi non autorizzati; gli allegati sono
                  conservati su sistemi ad accesso riservato.
                </p>
              </Section>

              <Section title="5. Comunicazione a terzi">
                <p>
                  I dati non vengono venduti né comunicati a terzi per finalità di
                  marketing. Possono essere trattati da fornitori di servizi
                  tecnici (hosting, invio di email transazionali) che operano per
                  nostro conto nel rispetto della normativa applicabile.
                </p>
              </Section>

              <Section title="6. I tuoi diritti">
                <p>
                  Ai sensi della Legge federale sulla protezione dei dati (nLPD) e,
                  ove applicabile, del GDPR, hai diritto di accesso, rettifica,
                  cancellazione e opposizione al trattamento dei tuoi dati personali.
                  Per esercitare questi diritti puoi contattarci ai recapiti indicati
                  al punto 1.
                </p>
              </Section>

              <Section title="7. Modifiche">
                <p>
                  La presente informativa può essere aggiornata in caso di modifiche
                  organizzative o normative. La versione vigente è quella pubblicata
                  su questa pagina.
                </p>
              </Section>
            </div>
          </FadeUp>
        </div>
      </div>
    </div>
  );
}
